export default {
  // Login
  'login.title': '管理员登录',
  'login.subtitle': '请使用管理员账号登录，账号由超级管理员分配',
  'login.email': '用户名 / 邮箱',
  'login.emailPlaceholder': '请输入用户名或邮箱',
  'login.password': '密码',
  'login.passwordPlaceholder': '请输入密码',
  'login.submit': '登录',
  'login.loading': '登录中...',
  'login.failed': '登录失败',
  'login.networkError': '网络错误',
  'login.unknownError': '未知错误',
  'login.emptyFields': '请输入用户名和密码',
  'login.showPassword': '显示密码',
  'login.hidePassword': '隐藏密码',
  'login.noSelfRegister': '本平台不提供自助注册。如需账号，请联系您的超级管理员进行开设。',
  'login.footerText': '多租户管理平台',
  'login.brandTitle1': '多租户管理',
  'login.brandTitle2': '控制台',
  'login.brandSlogan': '统一管理您的租户、用户、资源与计费策略，让企业级运营更高效、更安全。',
  'login.feature1Title': '权限管控',
  'login.feature1Desc': '企业级权限管控与审计日志',
  'login.feature2Title': '数据隔离',
  'login.feature2Desc': '多租户数据隔离与配额管理',
  'login.feature3Title': '监控分析',
  'login.feature3Desc': '实时监控仪表盘与报表分析',

  // Sidebar
  'sidebar.home': '首页概览',
  'sidebar.users': '用户与权限',
  'sidebar.resources': '功能与资源',
  'sidebar.tenants': '租户管理',
  'sidebar.audit': '审计日志',
  'sidebar.reports': '报表分析',
  'sidebar.settings': '系统设置',
  'sidebar.plans': '套餐管理',
  'sidebar.waitlist': '等待列表',
  'sidebar.admin': '系统管理员',

  // Header
  'header.search': '搜索租户、用户、资源...',
  'header.notifications': '通知',
  'header.viewAll': '查看全部通知',
  'header.profile': '个人资料',
  'header.settings': '设置',
  'header.logout': '退出登录',
  'header.notif.newTenant': '新租户注册',
  'header.notif.newTenantMsg': '科技创新有限公司已注册',
  'header.notif.apiWarning': 'API 使用警告',
  'header.notif.apiWarningMsg': '租户 T002 接近配额限制',
  'header.notif.systemUpdate': '系统更新',
  'header.notif.systemUpdateMsg': '系统将于今晚维护',
  'header.notif.5minAgo': '5分钟前',
  'header.notif.1hourAgo': '1小时前',
  'header.notif.3hoursAgo': '3小时前',

  // Home
  'home.title': '管理概览',
  'home.subtitle': '欢迎回来，这是您的多租户管理平台',
  'home.totalTenants': '总租户数',
  'home.totalUsers': '总用户数',
  'home.apiCalls': 'API 调用',
  'home.totalRevenue': '总收入',
  'home.totalSkills': '总技能数',
  'home.chatSessions': '对话会话',
  'home.totalMessages': '消息总数',
  'home.systemHealth': '系统健康度',
  'home.active': '个活跃',
  'home.activeShort': '活跃',
  'home.thisMonth': '本月',
  'home.published': '已发布',
  'home.cumulative': '累计',
  'home.running': '运行正常',
  'home.vsLastMonth': 'vs 上月',
  'home.apiTrend': 'API 使用趋势',
  'home.revenueTrend': '收入趋势',
  'home.quickAccess': '快速入口',
  'home.recentActivity': '最近活动',
  'home.viewAll': '查看全部',
  'home.tenantDistribution': '租户分布',
  'home.success': '成功',
  'home.failed': '失败',
  'home.todayNewUsers': '今日新注册',
  'home.todayNewUsersDesc': '今日注册用户',

  // Tenants
  'tenants.title': '租户管理',
  'tenants.subtitle': '管理所有租户的配置、配额与计费策略',
  'tenants.export': '导出列表',
  'tenants.create': '新建租户',
  'tenants.total': '共',
  'tenants.unit': '个租户',
  'tenants.clickTip': '点击行可查看详情',
  'tenants.showing': '显示',
  'tenants.to': '-',
  'tenants.of': '条，共',
  'tenants.records': '条',
  'tenants.createTitle': '新建租户',
  'tenants.createSuccess': '租户创建成功！',
  'tenants.createFailed': '创建失败',
  'tenants.tenantName': '租户名称',
  'tenants.subdomain': '子域名',
  'tenants.contactName': '联系人姓名',
  'tenants.contactEmail': '联系邮箱',
  'tenants.planType': '套餐类型',
  'tenants.deployRegion': '部署区域',
  'tenants.cancel': '取消',
  'tenants.createBtn': '创建租户',
  'tenants.namePlaceholder': '例：科技创新有限公司',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': '张三',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': '基础版',
  'tenants.plan.professional': '专业版',
  'tenants.plan.enterprise': '企业版',
  'tenants.region.global': '全球',
  'tenants.region.east': '华东',
  'tenants.region.north': '华北',
  'tenants.region.south': '华南',
  'tenants.region.west': '华西',
  'tenants.status.active': '活跃',
  'tenants.status.suspended': '已暂停',
  'tenants.status.inactive': '未激活',
  'tenants.confirmDelete': '确定要删除该组织吗？此操作不可撤销。',
  'tenants.loading': '加载中...',
  'tenants.modal.name': '组织名称',
  'tenants.modal.namePlaceholder': '请输入组织名称',
  'tenants.modal.status': '状态',
  'tenants.modal.region': '区域',
  'tenants.modal.cancel': '取消',
  'tenants.modal.save': '保存',
  'tenants.modal.saving': '保存中...',
  'tenants.modal.createTitle': '新建组织',
  'tenants.modal.editTitle': '编辑组织',

  // Tenant Stats
  'tenantStats.total': '组织总数',
  'tenantStats.inactive': '非活跃组织',
  'tenantStats.active': '活跃租户',
  'tenantStats.totalUsers': '总用户数',
  'tenantStats.monthlyRevenue': '本月收入',

  // Tenant Filters
  'tenantFilters.searchTenant': '搜索组织名称...',
  'tenantFilters.search': '搜索租户名称、域名或联系人...',
  'tenantFilters.inactive': '未激活',
  'tenantFilters.allPlans': '所有套餐',
  'tenantFilters.allStatus': '所有状态',
  'tenantFilters.active': '活跃',
  'tenantFilters.suspended': '已暂停',
  'tenantFilters.trial': '试用中',

  // Tenant Table
  'tenantTable.info': '租户信息',
  'tenantTable.plan': '套餐',
  'tenantTable.status': '状态',
  'tenantTable.users': '用户数',
  'tenantTable.apiCalls': 'API调用',
  'tenantTable.storage': '存储',
  'tenantTable.region': '区域',
  'tenantTable.lastActive': '最后活跃',
  'tenantTable.actions': '操作',
  'tenantTable.viewDetail': '查看详情',
  'tenantTable.edit': '编辑',
  'tenantTable.delete': '删除',
  'tenantTable.createdAt': '创建时间',
  'tenantTable.more': '更多操作',
  'tenantTable.noMatch': '暂无匹配的租户',

  // Tenant Detail
  'tenantDetail.basicInfo': '基本信息',
  'tenantDetail.actions': '操作',
  'tenantDetail.editTenant': '编辑组织',
  'tenantDetail.viewUsers': '查看用户',
  'tenantDetail.overview': '概览',
  'tenantDetail.quotaMgmt': '配额管理',
  'tenantDetail.dataIsolation': '数据隔离',
  'tenantDetail.billing': '计费信息',
  'tenantDetail.createdAt': '创建于',
  'tenantDetail.resourceUsage': '资源使用情况',
  'tenantDetail.apiCallUsage': 'API 调用量',
  'tenantDetail.storageUsage': '存储空间',
  'tenantDetail.userCount': '用户数量',
  'tenantDetail.contactInfo': '联系信息',
  'tenantDetail.contact': '联系人',
  'tenantDetail.email': '邮箱',
  'tenantDetail.deployRegion': '部署区域',
  'tenantDetail.lastActive': '最后活跃',
  'tenantDetail.enabledFeatures': '已开通功能',
  'tenantDetail.tags': '租户标签',
  'tenantDetail.quickActions': '快捷操作',
  'tenantDetail.suspend': '暂停租户',
  'tenantDetail.resume': '恢复租户',
  'tenantDetail.sendNotice': '发送通知',
  'tenantDetail.simulateLogin': '模拟登录',
  'tenantDetail.exportData': '导出数据',
  'tenantDetail.quotaSaved': '配额已保存',
  'tenantDetail.quotaSettings': '配额设置',
  'tenantDetail.quotaDesc': '调整该租户的资源使用上限',
  'tenantDetail.maxUsers': '最大用户数',
  'tenantDetail.apiCallsMonth': 'API 调用量/月',
  'tenantDetail.storageSpace': '存储空间',
  'tenantDetail.currentUsage': '当前使用',
  'tenantDetail.saveQuota': '保存配额设置',
  'tenantDetail.isolationSaved': '隔离策略已保存',
  'tenantDetail.isolationPolicy': '数据隔离策略',
  'tenantDetail.isolationDesc': '选择该租户的数据存储与隔离方式',
  'tenantDetail.dedicated': '独立隔离',
  'tenantDetail.dedicatedDesc': '为该租户分配独立的数据库实例，数据完全隔离，安全性最高，适合企业级客户',
  'tenantDetail.shared': '共享隔离',
  'tenantDetail.sharedDesc': '与其他租户共享数据库实例，通过行级安全策略隔离数据，成本更低',
  'tenantDetail.recommended': '推荐',
  'tenantDetail.permissionConfig': '权限细分配置',
  'tenantDetail.crossTenantAccess': '跨租户数据访问',
  'tenantDetail.crossTenantDesc': '允许该租户访问其他租户的公开数据',
  'tenantDetail.apiRateLimit': 'API 速率限制',
  'tenantDetail.apiRateLimitDesc': '对该租户的 API 请求进行速率限制',
  'tenantDetail.dataExport': '数据导出权限',
  'tenantDetail.dataExportDesc': '允许该租户导出其数据',
  'tenantDetail.auditAccess': '审计日志访问',
  'tenantDetail.auditAccessDesc': '允许该租户查看自身的审计日志',
  'tenantDetail.saveIsolation': '保存隔离策略',
  'tenantDetail.currentPlan': '当前套餐费用',
  'tenantDetail.perMonth': '/ 月',
  'tenantDetail.nextBilling': '下次账单日',
  'tenantDetail.billDetail': '账单明细',
  'tenantDetail.baseFee': '基础套餐费',
  'tenantDetail.apiCallFee': 'API 调用费',
  'tenantDetail.storageFee': '存储费用',
  'tenantDetail.supportFee': '技术支持费',
  'tenantDetail.total': '合计',
  'tenantDetail.historyBills': '历史账单',
  'tenantDetail.paid': '已支付',
  'tenantDetail.download': '下载',
  'tenantDetail.feature.aiModels': 'AI 模型',
  'tenantDetail.feature.apiAccess': 'API 接入',
  'tenantDetail.feature.advancedAnalytics': '高级分析',
  'tenantDetail.feature.basicAnalytics': '基础分析',
  'tenantDetail.feature.customDomain': '自定义域名',
  'tenantDetail.feature.sso': 'SSO 单点登录',
  'tenantDetail.feature.whiteLabel': '白标定制',

  // Users
  'users.title': '用户与权限管理',
  'users.subtitle': '管理所有租户的用户账户和权限配置',
  'users.addUser': '添加用户',
  'users.totalUsers': '总用户数',
  'users.activeUsers': '活跃用户',
  'users.admins': '管理员',
  'users.developers': '开发者',
  'users.loading': '加载中...',
  'users.confirmDelete': '确定要删除该用户吗？',
  'users.role.user': '普通用户',
  'users.role.admin': '管理员',
  'users.role.developer': '开发者',
  'users.status.active': '活跃',
  'users.status.inactive': '未激活',
  'users.status.suspended': '已停用',
  'users.status.banned': '已封禁',
  'users.modal.name': '姓名',
  'users.modal.email': '邮箱',
  'users.modal.password': '密码',
  'users.modal.passwordEditHint': '（留空不修改）',
  'users.modal.passwordEditPlaceholder': '留空不修改',
  'users.modal.passwordPlaceholder': '设置密码',
  'users.modal.role': '角色',
  'users.modal.status': '状态',
  'users.modal.tenant': '所属组织',
  'users.modal.cancel': '取消',
  'users.modal.save': '保存',
  'users.modal.saving': '保存中...',
  'users.modal.editTitle': '编辑用户',
  'users.modal.addTitle': '添加用户',

  // User Filters
  'userFilters.search': '搜索用户名、邮箱或租户...',
  'userFilters.allRoles': '所有角色',
  'userFilters.admin': '管理员',
  'userFilters.user': '普通用户',
  'userFilters.developer': '开发者',
  'userFilters.allStatus': '所有状态',
  'userFilters.active': '活跃',
  'userFilters.inactive': '未激活',
  'userFilters.suspended': '已停用',
  'userFilters.banned': '已封禁',
  'userFilters.moreFilters': '更多筛选',

  // User Table
  'userTable.user': '用户',
  'userTable.tenant': '租户',
  'userTable.role': '角色',
  'userTable.status': '状态',
  'userTable.lastLogin': '最后登录',
  'userTable.actions': '操作',
  'userTable.role.admin': '管理员',
  'userTable.role.user': '用户',
  'userTable.role.developer': '开发者',
  'userTable.status.active': '活跃',
  'userTable.status.inactive': '未激活',
  'userTable.status.suspended': '已停用',
  'userTable.status.banned': '已封禁',
  'userTable.edit': '编辑',
  'userTable.delete': '删除',
  'userTable.noData': '暂无用户数据',

  // Resources
  'resources.title': '服务配置',
  'resources.subtitle': '管理 AI 模型、API 密钥和第三方服务集成',
  'resources.refresh': '刷新',
  'resources.addConfig': '添加配置',
  'resources.totalConfigs': '总配置数',
  'resources.active': '已启用',
  'resources.categories': '分类',
  'resources.secrets': '密钥',
  'resources.addTitle': '添加新配置',
  'resources.category': '分类',
  'resources.configKey': '配置键',
  'resources.displayName': '显示名称',
  'resources.value': '值',
  'resources.description': '描述',
  'resources.secretValue': '加密值',
  'resources.type': '类型：',
  'resources.save': '保存',
  'resources.cancel': '取消',
  'resources.create': '创建',
  'resources.configs': '个配置',
  'resources.items': '项',
  'resources.notConfigured': '未配置',
  'resources.noConfigs': '未找到配置',
  'resources.running': '运行中',
  'resources.maintenance': '维护中',
  'resources.endpoint': '端点',
  'resources.usageTenants': '使用租户',
  'resources.usageUnit': '个',
  'resources.usage': '使用量',
  'resources.configure': '配置',
  'resources.stats': '统计',
  'resources.modelType': '类型',
  'resources.version': '版本',
  'resources.callCount': '调用次数',
  'resources.cost': '成本',
  'resources.apiKey': 'API 密钥',
  'resources.edit': '编辑',
  'resources.usageStats': '使用统计',

  // Settings
  'settings.title': '系统设置',
  'settings.subtitle': '管理平台全局配置、安全策略与多语言选项',
  'settings.tab.general': '基本设置',
  'settings.tab.services': '服务配置',
  'settings.tab.security': '安全配置',
  'settings.tab.notification': '通知设置',
  'settings.tab.billing': '计费方案',
  'settings.tab.locale': '多语言',
  'settings.tab.registration': '注册管理',
  'settings.tab.points': '积分规则',
  'settings.systemInfo': '系统信息',
  'settings.version': '版本',
  'settings.environment': '环境',
  'settings.production': '生产环境',
  'settings.availability': '可用率',
  'settings.lastBackup': '上次备份',
  'settings.todayAt': '今日 03:00',

  // General Settings
  'general.platformInfo': '平台基本信息',
  'general.platformName': '平台名称',
  'general.platformUrl': '平台地址',
  'general.supportEmail': '支持邮箱',
  'general.timezone': '时区',
  'general.dateFormat': '日期格式',
  'general.maxTenants': '最大租户数/方案',
  'general.sessionMaintenance': '会话与维护',
  'general.sessionTimeout': '会话超时时间',
  'general.sessionTimeoutDesc': '用户无操作后自动退出登录',
  'general.minutes': '分钟',
  'general.maintenanceMode': '维护模式',
  'general.maintenanceDesc': '开启后前台用户将看到维护提示页面',
  'general.maintenanceWarning': '维护模式已开启，所有前台用户将无法访问平台，请谨慎操作。',
  'general.reset': '重置',
  'general.save': '保存设置',
  'general.saved': '已保存',

  // Security Settings
  'security.authPolicy': '认证策略',
  'security.mfa': '强制多因素认证 (MFA)',
  'security.mfaDesc': '所有管理员账号必须启用 MFA',
  'security.sso': 'SSO 单点登录',
  'security.ssoProtocol': '当前协议',
  'security.passwordPolicy': '密码策略',
  'security.minLength': '最小密码长度',
  'security.chars': '位字符',
  'security.expireDays': '密码有效期',
  'security.days': '天',
  'security.maxAttempts': '最大登录失败次数',
  'security.times': '次',
  'security.lockoutDuration': '账号锁定时长',
  'security.ipWhitelist': 'IP 白名单',
  'security.ipPlaceholder': '输入 IP 或 CIDR，如 192.168.1.0/24',
  'security.add': '添加',
  'security.ipWhitelistDesc': '开启后，仅允许白名单内的 IP 地址访问管理后台。',
  'security.auditLog': '审计日志',
  'security.retentionDays': '日志保留天数',
  'security.retentionDesc': '超过保留期的日志将自动清理',
  'security.reset': '重置',
  'security.save': '保存设置',
  'security.saved': '已保存',

  // Notification Settings
  'notification.channels': '通知渠道',
  'notification.email': '邮件通知',
  'notification.emailDesc': '通过邮件发送系统告警和报告',
  'notification.sms': '短信通知',
  'notification.smsDesc': '通过短信发送紧急告警',
  'notification.webhook': 'Webhook 推送',
  'notification.webhookDesc': '将事件推送到指定 URL',
  'notification.webhookUrl': 'Webhook URL',
  'notification.alertEvents': '告警事件',
  'notification.tenantCreate': '新租户注册',
  'notification.tenantCreateDesc': '有新租户完成注册时通知',
  'notification.quotaExceed': '配额超限告警',
  'notification.quotaExceedDesc': '租户 API 用量超过 90% 时通知',
  'notification.loginFail': '登录失败告警',
  'notification.loginFailDesc': '连续登录失败达到阈值时通知',
  'notification.systemError': '系统错误告警',
  'notification.systemErrorDesc': '系统发生严重错误时立即通知',
  'notification.scheduledReport': '定时报告',
  'notification.dailyReport': '每日报告',
  'notification.dailyReportDesc': '每天定时发送运营数据摘要',
  'notification.sendTime': '发送时间',
  'notification.recipients': '报告接收人',
  'notification.emailPlaceholder': '输入邮箱地址',
  'notification.addBtn': '添加',
  'notification.reset': '重置',
  'notification.save': '保存设置',
  'notification.saved': '已保存',

  // Billing Plans
  'billing.saved': '方案已保存',
  'billing.totalPlans': '方案总数',
  'billing.activePlans': '启用方案',
  'billing.highestPrice': '最高定价',
  'billing.editing': '编辑中',
  'billing.cancel': '取消',
  'billing.save': '保存',
  'billing.planName': '方案名称',
  'billing.monthlyFee': '月费 (CNY)',
  'billing.apiCallsMonth': 'API 调用量/月',
  'billing.storageSpace': '存储空间 (GB)',
  'billing.maxUsers': '最大用户数',
  'billing.supportType': '支持方式',
  'billing.disabled': '已停用',
  'billing.perMonth': '/ 月',
  'billing.edit': '编辑',
  'billing.apiLabel': 'API 调用',
  'billing.storageLabel': '存储空间',
  'billing.usersLabel': '用户数',
  'billing.supportLabel': '支持方式',

  // Locale Settings
  'locale.defaultLang': '默认语言设置',
  'locale.platformDefault': '平台默认语言',
  'locale.platformDefaultDesc': '新用户首次访问时使用此语言',
  'locale.fallbackLang': '回退语言',
  'locale.fallbackLangDesc': '翻译缺失时使用此语言兜底',
  'locale.autoDetect': '自动检测浏览器语言',
  'locale.autoDetectDesc': '根据用户浏览器设置自动切换语言',
  'locale.tenantOverride': '允许租户自定义语言',
  'locale.tenantOverrideDesc': '租户可在其设置中覆盖平台默认语言',
  'locale.langManagement': '语言包管理',
  'locale.enabled': '已启用',
  'locale.default': '默认',
  'locale.translationCoverage': '翻译覆盖率',
  'locale.cannotDisable': '默认语言不可禁用',
  'locale.coverageNote': '翻译覆盖率说明',
  'locale.coverageDesc': '覆盖率低于 80% 的语言包可能存在部分界面显示为回退语言的情况。建议在覆盖率达到 90% 以上后再对外启用。',
  'locale.save': '保存设置',
  'locale.saved': '已保存',

  // Service Configs (Settings tab)
  'serviceConfigs.title': '服务配置',
  'serviceConfigs.subtitle': '管理 AI 模型、第三方 API 密钥和外部服务集成',
  'serviceConfigs.refresh': '刷新',

  // Audit
  'audit.title': '审计日志',
  'audit.subtitle': '系统操作记录与安全审计',
  'audit.totalLogs': '总日志数',
  'audit.totalLogsDesc': '所有操作记录',
  'audit.successOps': '成功操作',
  'audit.successRate': '成功率',
  'audit.failedOps': '失败操作',
  'audit.failedDesc': '需要关注处理',
  'audit.todayOps': '今日操作',
  'audit.todayDesc': '今日活跃度',
  'audit.tenant': '租户',
  'audit.allTenants': '全部租户',
  'audit.actionType': '操作类型',
  'audit.allActions': '全部操作',
  'audit.status': '状态',
  'audit.allStatus': '全部状态',
  'audit.success': '成功',
  'audit.failed': '失败',
  'audit.timeRange': '时间范围',
  'audit.allTime': '全部时间',
  'audit.today': '今天',
  'audit.last7days': '近7天',
  'audit.last30days': '近30天',
  'audit.keyword': '关键词搜索',
  'audit.keywordPlaceholder': '搜索用户、操作、资源...',
  'audit.found': '找到',
  'audit.records': '条记录',
  'audit.clearFilter': '清除筛选',
  'audit.time': '时间',
  'audit.user': '用户',
  'audit.action': '操作',
  'audit.resource': '资源',
  'audit.ipAddress': 'IP地址',
  'audit.actions': '操作',
  'audit.viewDetail': '查看详情',
  'audit.showing': '显示',
  'audit.prevPage': '上一页',
  'audit.nextPage': '下一页',
  'audit.detailTitle': '操作详情',
  'audit.logId': '日志ID',
  'audit.operationTime': '操作时间',
  'audit.operationStatus': '操作状态',
  'audit.tenantInfo': '租户信息',
  'audit.tenantId': '租户ID',
  'audit.tenantName': '租户名称',
  'audit.operationUser': '操作用户',
  'audit.userId': '用户ID',
  'audit.userName': '用户名称',
  'audit.operationInfo': '操作信息',
  'audit.operationType': '操作类型',
  'audit.operationResource': '操作资源',
  'audit.operationDetail': '操作详情',
  'audit.networkInfo': '网络信息',
  'audit.userAgent': 'User Agent',

  // Reports
  'reports.title': '报表分析',
  'reports.subtitle': '多维度数据分析与可视化报表',
  'reports.last7days': '近7天',
  'reports.last30days': '近30天',
  'reports.last90days': '近90天',
  'reports.apiTrend': 'API调用量趋势',
  'reports.revenueCompare': '租户收入对比',
  'reports.resourceUsage': '资源使用率',
  'reports.userActivity': '用户活跃度趋势',
  'reports.activeUsers': '活跃用户',
  'reports.newUsers': '新增用户',
  'reports.tenantSummary': '租户数据汇总',
  'reports.tenantName': '租户名称',
  'reports.apiCalls': 'API调用',
  'reports.storageUsage': '存储用量',
  'reports.userCount': '用户数',
  'reports.revenue': '收入',
  'reports.quotaUsage': '配额使用率',

  // Language Switcher
  'langSwitcher.title': '语言 / Language',

  // Resource Panels
  'res.llm.title': 'AI 模型 & API',
  'res.llm.subtitle': 'LLM、Embedding、图像生成、语音识别等 AI 服务接入',
  'res.llm.monthlyCost': '本月总费用',
  'res.llm.usingTenants': '使用租户',
  'res.llm.monthlyTokens': '本月 Tokens',
  'res.llm.monthlyCost2': '本月费用',
  'res.llm.monthlyCalls': '本月调用',
  'res.llm.tenants': '使用租户',
  'res.llm.maxContext': '最大输出',
  'res.llm.model': '模型',
  'res.llm.configure': '配置',
  'res.llm.configTitle': '配置',
  'res.llm.apiKey': 'API 密钥',
  'res.llm.modelName': '模型名称',
  'res.llm.maxTokens': '最大 Token 数',
  'res.llm.all': '全部',
  'res.llm.imageGen': '图像生成',
  'res.llm.speechRecog': '语音识别',
  'res.status.running': '运行中',
  'res.status.maintenance': '维护中',
  'res.status.monitoring': '监控中',
  'res.status.disabled': '未启用',
  'res.status.error': '异常',
  'res.status.enabled': '已启用',
  'res.email.title': '邮件服务',
  'res.email.subtitle': '注册验证、密码重置、通知邮件',
  'res.email.sender': '发件人',
  'res.email.dailySent': '今日发送',
  'res.email.monthlyTotal': '本月累计',
  'res.email.details': '详情',
  'res.email.configure': '配置',
  'res.email.notConfigured': '未配置',
  'res.email.apiKey': 'API 密钥',
  'res.email.senderEmail': '发件人邮箱',
  'res.email.senderName': '发件人名称',
  'res.email.dailyLimit': '每日发送上限',
  'res.payment.title': '支付网关',
  'res.payment.subtitle': '订阅付费、一次性付款、退款处理',
  'res.payment.monthlyVolume': '本月流水',
  'res.payment.tenThousand': '万',
  'res.payment.successRate': '成功率',
  'res.payment.currencies': '支持货币',
  'res.payment.configKeys': '配置密钥',
  'res.payment.publicKey': '公钥 / App ID',
  'res.payment.secretKey': '私钥 / Secret Key',
  'res.payment.webhookSecret': 'Webhook 签名密钥',
  'res.storage.title': '对象存储',
  'res.storage.subtitle': '用户头像、文件上传、媒体资源存储',
  'res.storage.usedSpace': '已用空间',
  'res.storage.totalQuota': '总配额',
  'res.storage.monthlyRequests': '本月请求',
  'res.storage.usageRate': '存储使用率',
  'res.storage.configure': '配置',
  'res.sms.title': '短信服务',
  'res.sms.subtitle': '双因素认证、验证码、通知短信',
  'res.sms.dailySent': '今日发送',
  'res.sms.monthlyTotal': '本月累计',
  'res.sms.dailyQuota': '今日配额',
  'res.sms.configure': '配置',
  'res.sms.sendNumber': '发送号码 / 签名',
  'res.sms.dailyLimit': '每日发送上限',
  'res.monitoring.title': '错误监控',
  'res.monitoring.subtitle': '线上异常追踪、性能监控、告警通知',
  'res.monitoring.monthlyErrors': '本月错误',
  'res.monitoring.monthlyQuota': '月配额',
  'res.monitoring.sampleRate': '采样率',
  'res.monitoring.quotaUsage': '月配额使用',
  'res.monitoring.environment': '环境',
  'res.monitoring.alertEmail': '告警邮箱',
  'res.monitoring.perfSample': '性能追踪采样',
  'res.monitoring.configure': '配置',
  'res.monitoring.dsn': 'DSN 地址',
  'res.monitoring.env': '环境',
  'res.monitoring.errorRate': '错误采样率 (0~1)',
  'res.monitoring.perfRate': '性能追踪采样率 (0~1)',
  'res.monitoring.alertAddr': '告警邮箱',
  'res.modal.cancel': '取消',
  'res.modal.saved': '已保存',
  'res.modal.saveConfig': '保存配置',
  'res.category.llm': 'AI 模型 & API',
  'res.category.email': '邮件服务',
  'res.category.payment': '支付网关',
  'res.category.storage': '对象存储',
  'res.category.sms': '短信服务',
  'res.category.monitoring': '错误监控',
  'res.category.workers': '后台进程',
  'res.workers.title': '后台进程管理',
  'res.workers.subtitle': '监控和管理后台运行的调度器、压缩器等服务',
  'res.workers.categoryDesc': '通知调度 / 主动消息 / 上下文压缩 / 异步任务',
  'res.workers.onlineUsers': '在线用户',
  'res.workers.stopped': '已停止',
  'res.workers.interval': '执行间隔',
  'res.workers.uptime': '运行时长',
  'res.workers.lastScan': '最近一次扫描',
  'res.workers.scanDuration': '扫描耗时',
  'res.workers.todayScans': '今日扫描',
  'res.workers.todayDelivered': '今日投递',
  'res.workers.todayFailed': '今日失败',
  'res.workers.totalDelivered': '累计投递',
  'res.workers.totalFailed': '累计失败',
  'res.workers.totalScans': '累计扫描',
  'res.workers.userBreakdown': '按用户明细',
  'res.workers.userId': '用户 ID',
  'res.workers.cumulativeDelivered': '累计投递',
  'res.workers.cumulativeFailed': '累计失败',
  'res.workers.estTokens': '预估 Tokens',
  'res.workers.estCost': '预估费用',
  'res.workers.skipped': '跳过次数 (未达阈值)',
  'res.workers.lastCompressedSession': '最近压缩会话',

  // Resource category descriptions
  'res.category.speech': '语音服务',
  'res.category.llmDesc': 'LLM / Embedding / VLM / OCR / 图生 / 文档',
  'res.category.speechDesc': 'ASR / TTS / 文件转写 / 多模态交互',
  'res.category.emailDesc': '腾讯云 SES / SendGrid / AWS SES',
  'res.category.storageDesc': '阿里云 OSS',

  // Status badges
  'res.status.pendingConfig': '待配置',
  'res.status.pendingKey': '待配置 Key',
  'res.status.stopped': '已停用',

  // AddConfig modal
  'res.addConfig.title': '添加配置',
  'res.addConfig.category': '分类',
  'res.addConfig.configKey': '配置键',
  'res.addConfig.displayName': '显示名称',
  'res.addConfig.valueType': '值类型',
  'res.addConfig.value': '值',
  'res.addConfig.valuePlaceholder': '配置值',
  'res.addConfig.description': '描述',
  'res.addConfig.descriptionPlaceholder': '可选描述',
  'res.addConfig.secretLabel': '加密值（API 响应中将被遮掩）',
  'res.addConfig.requiredError': '配置键和显示名称为必填项',
  'res.addConfig.createFailed': '创建配置失败',
  'res.addConfig.saving': '保存中...',

  // Modal common
  'res.modal.saving': '保存中...',
  'res.modal.leaveEmptyNoChange': '留空则不修改',
  'res.modal.leaveEmptyHint': '留空表示不修改当前值',
  'res.modal.pleaseInput': '请输入...',

  // Email panel
  'res.email.tencentSES': '腾讯云 SES',
  'res.email.regionChina': '中国大陆',
  'res.email.featureVerify': '注册验证',
  'res.email.featureReset': '密码重置',
  'res.email.featureNotify': '通知邮件',
  'res.email.loading': '加载邮件配置...',
  'res.email.configSmtp': '配置腾讯云 SES SMTP',

  // SMS panel
  'res.sms.secretPlaceholder': '请输入密钥',

  // Speech panel
  'res.speech.title': '语音服务配置',
  'res.speech.subtitle': '管理 ASR 语音识别和 TTS 语音合成服务',
  'res.speech.enabled': '已启用',
  'res.speech.monthlyCalls': '本月调用',
  'res.speech.cost': '费用',
  'res.speech.loading': '加载语音服务配置...',
  'res.speech.noConfig': '尚未配置语音服务',
  'res.speech.noConfigHint': '请先运行 seed 初始化语音服务配置',
  'res.speech.noApiKey': '未设置 API Key',
  'res.speech.callsUnit': '次',
  'res.speech.monthlyCost': '本月费用',
  'res.speech.model': '模型',
  'res.speech.unitPrice': '单价',
  'res.speech.configure': '配置',
  'res.speech.voice': '音色',
  'res.speech.format': '输出格式',
  'res.speech.workspaceId': '工作空间 ID',
  'res.speech.appId': '应用 ID',
  'res.speech.upstreamSampleRate': '上行采样率',
  'res.speech.downstreamSampleRate': '下行采样率',
  'res.speech.asrLabel': 'ASR 实时语音识别',
  'res.speech.ttsLabel': 'TTS 实时语音合成',
  'res.speech.asrFileLabel': '文件转写',
  'res.speech.voiceCallLabel': '多模态交互',
  'res.speech.pricePerHour': '元/小时',
  'res.speech.pricePerKCalls': '元/千次',
  'res.speech.pricePerMinute': '元/分钟',
  'res.speech.featureRealtime': '实时流式',
  'res.speech.featureMultilang': '多语言',
  'res.speech.featureMultiVoice': '多音色',
  'res.speech.featureOffline': '离线转写',
  'res.speech.featureLongAudio': '长音频',
  'res.speech.featureDuplex': '双工对话',
  'res.speech.featureInterrupt': '语音打断',
  'res.speech.featureMemory': '记忆注入',

  // Storage panel
  'res.storage.loading': '加载存储服务配置...',
  'res.storage.noConfig': '尚未配置存储服务',
  'res.storage.noConfigHint': '请先运行 seed 初始化存储配置',
  'res.storage.aliOSS': '阿里云 OSS',
  'res.storage.tencentCOS': '腾讯云 COS',
  'res.storage.requestsUnit': '次',
  'res.storage.monthlyCost': '本月费用',
  'res.storage.notSet': '未设置',
  'res.storage.cdnDomain': 'CDN 域名',
  'res.storage.signExpiry': '签名有效期',
  'res.storage.signExpiryLabel': '签名 URL 有效期 (秒)',
  'res.storage.featureObjStorage': '对象存储',
  'res.storage.featureSignedUrl': '签名 URL',
  'res.storage.featureLifecycle': '生命周期',
  'res.storage.featureS3Compat': 'S3 兼容',
  'res.storage.featureCDN': 'CDN 加速',
  'res.storage.cdnPlaceholder': '可选，如 https://cdn.example.com',

  // LLM panel extra
  'res.llm.vlm': '视觉理解',
  'res.llm.docParse': '文档解析',
  'res.llm.ocrAlicloud': '读光OCR',
  'res.llm.ocrRecog': 'OCR 识别',
  'res.llm.noAccessKey': '未配置 AccessKey',
  'res.llm.noApiKey': '未设置 API Key',
  'res.llm.monthlyGenerated': '本月生成',
  'res.llm.imagesUnit': '张',
  'res.llm.defaultSize': '默认尺寸',
  'res.llm.unitPrice': '单价',
  'res.llm.perImage': '张',
  'res.llm.callsUnit': '次',
  'res.llm.inputPrice': '输入价格',
  'res.llm.outputPrice': '输出价格',
  'res.llm.vectorDim': '向量维度',
  'res.llm.loading': '加载已配置的 AI 服务...',
  'res.llm.apiEndpoint': 'API 端点',
  'res.llm.name': '名称',
  'res.llm.feat.semanticSearch': '语义搜索',
  'res.llm.feat.longTermMemory': '长期记忆',
  'res.llm.feat.vectorRetrieval': '向量检索',
  'res.llm.feat.imageUnderstanding': '图片理解',
  'res.llm.feat.sceneRecog': '场景识别',
  'res.llm.feat.multiTurn': '多轮对话',
  'res.llm.feat.text2img': '文生图',
  'res.llm.feat.multiSize': '多尺寸',
  'res.llm.feat.hdGen': '高清生成',
  'res.llm.feat.pdfParse': 'PDF解析',
  'res.llm.feat.longDocQA': '长文档QA',
  'res.llm.feat.tableExtract': '表格提取',
  'res.llm.feat.textRecog': '文字识别',
  'res.llm.feat.multiLang': '多语言',
  'res.llm.feat.handwriting': '手写识别',
  'res.llm.feat.chat': '对话',
  'res.llm.feat.codeGen': '代码生成',
  'res.llm.feat.textAnalysis': '文本分析',

  // Dashboard mock
  'dashboard.month.oct': '10月',
  'dashboard.month.nov': '11月',
  'dashboard.month.dec': '12月',
  'dashboard.month.jan': '1月',
  'dashboard.month.feb': '2月',
  'dashboard.month.mar': '3月',
  'dashboard.plan.enterprise': '企业版',
  'dashboard.plan.professional': '专业版',
  'dashboard.plan.basic': '基础版',
  'dashboard.plan.free': '免费版',
  'dashboard.action.createTenant': '创建租户',
  'dashboard.action.createTenantDesc': '添加新的租户账户',
  'dashboard.action.userMgmt': '用户管理',
  'dashboard.action.userMgmtDesc': '管理用户和权限',
  'dashboard.action.resourceConfig': '资源配置',
  'dashboard.action.resourceConfigDesc': '配置系统资源',
  'dashboard.action.auditLog': '审计日志',
  'dashboard.action.auditLogDesc': '查看系统日志',

  // Waitlist
  'waitlist.title': '等待列表',
  'waitlist.subtitle': '管理内测申请用户',
  'waitlist.confirmDelete': '确定删除？',
  'waitlist.pending': '待审核',
  'waitlist.totalApplications': '总申请',
  'waitlist.filter.all': '全部',
  'waitlist.filter.pending': '待审核',
  'waitlist.filter.approved': '已通过',
  'waitlist.filter.invited': '已邀请',
  'waitlist.filter.rejected': '已拒绝',
  'waitlist.loading': '加载中...',
  'waitlist.noData': '暂无数据',
  'waitlist.col.email': '邮箱',
  'waitlist.col.source': '来源',
  'waitlist.col.status': '状态',
  'waitlist.col.applyTime': '申请时间',
  'waitlist.col.actions': '操作',
  'waitlist.status.pending': '待审核',
  'waitlist.status.approved': '已通过',
  'waitlist.status.rejected': '已拒绝',
  'waitlist.status.invited': '已邀请',
  'waitlist.approve': '通过',
  'waitlist.reject': '拒绝',
  'waitlist.sendInvite': '发送邀请',
  'waitlist.delete': '删除',

  // Plans
  'plans.title': '套餐管理',
  'plans.subtitle': '管理订阅套餐、配额和定价策略',
  'plans.createPlan': '新建套餐',
  'plans.editPlanTitle': '编辑套餐 - {{name}}',
  'plans.planCode': '套餐编码',
  'plans.planCodePlaceholder': '如: free, pro, plus',
  'plans.planName': '套餐名称',
  'plans.planNamePlaceholder': '如: Free 免费版',
  'plans.pricing': '定价',
  'plans.monthlyPriceCents': '月费（分）',
  'plans.perMonth': '月',
  'plans.allowPaidSkill': '允许付费 Skill',
  'plans.quotaSettings': '配额设置',
  'plans.tokenQuota': 'Token 配额/月',
  'plans.requestQuota': '请求次数/月',
  'plans.skillCallQuota': 'Skill 调用/月',
  'plans.fileQuota': '文件数量/月',
  'plans.storageQuota': '存储空间 (MB)',
  'plans.cancel': '取消',
  'plans.saving': '保存中...',
  'plans.save': '保存',
  'plans.loading': '加载中...',
  'plans.planCount': '套餐数',
  'plans.totalSubscribers': '总订阅用户',
  'plans.monthlyRequests': '本月请求量',
  'plans.monthlyTokenUsage': '本月 Token 用量',
  'plans.free': '免费',
  'plans.currentSubs': '当前订阅',
  'plans.subsCount': '{{count}} 人',
  'plans.tokenQuotaLabel': 'Token 配额',
  'plans.requestQuotaLabel': '请求次数',
  'plans.skillCallLabel': 'Skill 调用',
  'plans.fileQuotaLabel': '文件数量',
  'plans.storageLabel': '存储空间',
  'plans.paidSkillLabel': '付费 Skill',
  'plans.enabled': '已开通',
  'plans.disabled': '未开通',
  'plans.edit': '编辑',
  'plans.delete': '删除',
  'plans.cannotDeleteWithSubs': '该套餐下还有订阅用户，无法删除',
  'plans.confirmDelete': '确定要删除该套餐吗？',
  'plans.monthlyUsageStats': '本月平台用量统计',
  'plans.metric': '指标',
  'plans.value': '数值',
  'plans.totalRequests': '总请求次数',
  'plans.tokenInput': 'Token 输入',
  'plans.tokenOutput': 'Token 输出',
  'plans.tokenTotal': 'Token 总计',

  // Registration Settings
  'settings.registration.mode': '注册模式',
  'settings.registration.modeDesc': '选择用户注册方式。开放注册允许任何人注册，邀请制注册需要有效邀请码。',
  'settings.registration.open': '开放注册',
  'settings.registration.openDesc': '任何人可注册',
  'settings.registration.invite': '邀请制注册',
  'settings.registration.inviteDesc': '需要邀请码',
  'settings.registration.cancel': '取消',
  'settings.registration.saving': '保存中...',
  'settings.registration.saved': '已保存',
  'settings.registration.saveSettings': '保存设置',
  'settings.registration.totalGenerated': '总生成数',
  'settings.registration.totalUsed': '已使用',
  'settings.registration.activeCodes': '有效码',
  'settings.registration.generateTitle': '生成邀请码',
  'settings.registration.generateCount': '生成数量',
  'settings.registration.maxUses': '每码可用次数',
  'settings.registration.times': '{{count}} 次',
  'settings.registration.unlimited': '不限次数',
  'settings.registration.inviteQuota': '新用户邀请配额',
  'settings.registration.quotaZero': '0 (不可邀请他人)',
  'settings.registration.quotaSlots': '{{count}} 个邀请名额',
  'settings.registration.expiry': '有效期',
  'settings.registration.days': '{{count}} 天',
  'settings.registration.neverExpire': '永不过期',
  'settings.registration.noteOptional': '备注（可选）',
  'settings.registration.notePlaceholder': '例如：内测用户批次1',
  'settings.registration.generating': '生成中...',
  'settings.registration.generateBtn': '生成邀请码',
  'settings.registration.inviteList': '邀请码列表',
  'settings.registration.noInvites': '暂无邀请码',
  'settings.registration.colCode': '邀请码',
  'settings.registration.colStatus': '状态',
  'settings.registration.colUsage': '使用',
  'settings.registration.colExpiry': '过期时间',
  'settings.registration.colNote': '备注',
  'settings.registration.colCreated': '创建时间',
  'settings.registration.colActions': '操作',
  'settings.registration.copy': '复制',
  'settings.registration.deactivate': '停用',
  'settings.registration.statusActive': '有效',
  'settings.registration.statusUsed': '已用完',
  'settings.registration.statusExpired': '已过期',
  'settings.registration.statusInactive': '已停用',

  // Points Settings
  'settings.points.rulesTitle': '积分规则配置',
  'settings.points.noConfigs': '暂无积分配置项',
  'settings.points.noConfigsHint': '请在系统配置中添加 category=points 的配置',
  'settings.points.cancel': '取消',
  'settings.points.saving': '保存中...',
  'settings.points.saved': '已保存',
  'settings.points.saveSettings': '保存设置',
  'settings.points.loadError': '加载积分配置失败',
  'settings.points.saveError': '保存失败',
  'settings.points.searchError': '搜索用户失败',
  'settings.points.operationFailed': '操作失败',
  'settings.points.adminGrant': '管理员发放',
  'settings.points.adminDeduct': '管理员扣除',
  'settings.points.grantSuccess': '成功发放 {{amount}} 积分给 {{user}}',
  'settings.points.deductSuccess': '成功扣除 {{amount}} 积分给 {{user}}',
  'settings.points.itemUpdated': '商品已更新',
  'settings.points.itemCreated': '商品已创建',
  'settings.points.confirmDelete': '确认下架「{{name}}」？',
  'settings.points.grantDeductTitle': '积分发放 / 扣除',
  'settings.points.searchUser': '搜索用户',
  'settings.points.searchPlaceholder': '输入邮箱或昵称搜索...',
  'settings.points.searchBtn': '搜索',
  'settings.points.amount': '积分数量',
  'settings.points.amountPlaceholder': '输入积分数量',
  'settings.points.description': '说明',
  'settings.points.descriptionPlaceholder': '操作说明（可选）',
  'settings.points.grant': '发放',
  'settings.points.deduct': '扣除',
  'settings.points.exchangeTitle': '积分兑换商品',
  'settings.points.addItem': '添加商品',
  'settings.points.editItem': '编辑商品',
  'settings.points.itemName': '商品名称',
  'settings.points.itemNamePlaceholder': '例：邀请额度 x5',
  'settings.points.itemType': '类型',
  'settings.points.costPoints': '兑换积分',
  'settings.points.stock': '库存 (0=无限)',
  'settings.points.icon': '图标 (Remix Icon)',
  'settings.points.sortOrder': '排序',
  'settings.points.quotaAmount': '额度数量',
  'settings.points.itemDesc': '描述',
  'settings.points.itemDescPlaceholder': '商品描述（可选）',
  'settings.points.update': '更新',
  'settings.points.create': '创建',
  'settings.points.noItems': '暂无兑换商品',
  'settings.points.colItem': '商品',
  'settings.points.colType': '类型',
  'settings.points.colPoints': '积分',
  'settings.points.colStockSold': '库存/已售',
  'settings.points.colStatus': '状态',
  'settings.points.colActions': '操作',
  'settings.points.unlimited': '无限',
  'settings.points.edit': '编辑',
  'settings.points.remove': '下架',
  'settings.points.typeInviteQuota': '邀请额度',
  'settings.points.typeTokenPack': 'Token 包',
  'settings.points.typePlanTime': '套餐时长',
  'settings.points.typeSkillUnlock': '技能解锁',
  'settings.points.typeCustom': '自定义',
  'settings.points.registerBonus': '注册奖励积分',
  'settings.points.dailyLogin': '每日登录奖励',
  'settings.points.inviteReward': '邀请奖励积分',
  'settings.points.inviteeBonus': '被邀请人奖励',
  'settings.points.messageCost': '每条消息消耗',
  'settings.points.voiceCost': '语音消息消耗',
  'settings.points.skillCallCost': '技能调用消耗',
  'settings.points.fileUploadCost': '文件上传消耗',
  'settings.points.enabled': '积分系统启用',
  'settings.points.dailyFreeMessages': '每日免费消息数',
  'settings.points.initialBalance': '新用户初始积分',

  // Billing (additional)
  'billing.noPlans': '暂无计费方案',
  'billing.tokenQuotaMonth': 'Token 配额/月',
  'billing.tokenQuota': 'Token 配额',
  'billing.paidSkills': '付费技能',
  'billing.yes': '是',
  'billing.no': '否',

  // Service Configs (Settings tab - additional)
  'settings.services.title': '服务配置',
  'settings.services.subtitle': '管理 AI 模型、第三方 API 密钥和外部服务集成',
  'settings.services.refresh': '刷新',
  'settings.services.itemCount': '{{count}} 项',
  'settings.services.notConfigured': '未配置',
  'settings.services.secret': '密钥',
  'settings.services.inactive': '未启用',
  'settings.services.enterValue': '输入值...',
  'settings.services.save': '保存',
  'settings.services.cancel': '取消',
  'settings.services.saved': '已保存',
  'settings.services.empty': '空',
  'settings.services.editTitle': '编辑',
  'settings.services.disable': '停用',
  'settings.services.enable': '启用',
  'settings.services.noConfigs': '未找到配置',
  'settings.services.catLlm': 'LLM / AI 模型',
  'settings.services.catEmbedding': 'Embedding 嵌入',
  'settings.services.catVision': '视觉模型 (VLM)',
  'settings.services.catImageGen': '图像生成',
  'settings.services.catDocParse': '文档解析',
  'settings.services.catSpeech': '语音 (ASR/TTS)',
  'settings.services.catEmail': '邮件',
  'settings.services.catStorage': '存储',
  'settings.services.catPayment': '支付',
  'settings.services.catSms': '短信',
  'settings.services.catOcr': 'OCR 文字识别',
  'settings.services.catMonitor': '监控',
};
